import Events from 'modules/events/Events';
import React, { useEffect } from 'react';
import CollapseProvider from 'context/general/Collapse';
import EventProvider from 'context/events/Event';
import EventsListProvider from 'context/events/EventsList';
import EventFilterProvider from 'context/events/EventFilter';
import TagsProvider from 'context/events/Tags';
import EventsNearToYouProvider from 'context/events/EventsNearToYou';
import UserProvider from 'context/user/User';
import BackButtonCollapseProvider from 'context/general/BackButtonCollapse';
import NearListAllProvider from 'context/events/NearListAll';

export default function Home() {
    return (
        <CollapseProvider>
            <EventsListProvider>
                <EventProvider>
                    <EventFilterProvider>
                        <TagsProvider>
                            <EventsNearToYouProvider>
                                <NearListAllProvider>
                                    <UserProvider>
                                        <BackButtonCollapseProvider>
                                            <Events />
                                        </BackButtonCollapseProvider>
                                    </UserProvider>
                                </NearListAllProvider>
                            </EventsNearToYouProvider>
                        </TagsProvider>
                    </EventFilterProvider>
                </EventProvider>
            </EventsListProvider>
        </CollapseProvider>
    )
}